/* eslint-disable no-unused-vars */
import axiosAuthenticated, { axiosApiInstance } from '@/api/axios'
import { setToken, getToken } from '@/utils'
import router from '@/router'

const state = {
  currentUser: null,
  isUserLoggedIn: false,
  token: getToken()
}

const getters = {
  currentUser: (state) => state.currentUser,
  isUserLoggedIn: (state) => state.isUserLoggedIn,
  token: (state) => state.token
}

const mutations = {
  SET_CURRENT_USER(state, payload) {
    state.currentUser = payload
  },
  SET_LOGGED_IN(state, payload) {
    state.isUserLoggedIn = payload
  },
  SET_TOKEN(state, payload) {
    state.token = payload
  }
}

const actions = {
  registerNewUser(_context, { payload, vm }) {
    const data = new FormData()

    for (const key in payload) {
      data.append(key, payload[key])
    }

    axiosApiInstance
      .post('/api/register/new_user', data)
      .then(() => {
        vm.clear()
        vm.$fire({
          title: vm.$t('messages.successTitle'),
          text: vm.$t('messages.successText'),
          type: 'success',
          timer: 1000
        }).then(() => {
          vm.$router.push('/auth/login')
        })
      })
      .catch((err) => {
        console.log(err.response)

        vm.clear()
        vm.$fire({
          title: vm.$t('messages.errorTitle'),
          text: vm.$t('messages.errorMessage'),
          type: 'error',
          timer: 1500
        })
      })
  },
  loginExistingUser({ commit, dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }

    axiosApiInstance
      .post('/api/auth/login', data)
      .then((res) => {
        setToken(res.data.access_token)
        commit('SET_TOKEN', res.data.access_token)
        commit('SET_LOGGED_IN', true)
        commit('SET_CURRENT_USER', res.data.user)
        if (vm.$route.query && Object.keys(vm.$route.query).length > 0) {
          vm.$router.push(vm.$route.query.redirectFrom)
        } else {
          vm.$router.push('/user')
        }
      })
      .catch((err) => {
        if (err.response && err.response.status) {
          commit('SET_LOGGED_IN', false)
        }
      })
      .finally(() => {
        vm.clear()
      })
  },
  fetchUser({ commit, dispatch }) {
    const token = getToken()
    if (token) {
      axiosAuthenticated
        .post('/api/auth/me')
        .then((res) => {
          commit('SET_LOGGED_IN', true)
          commit('SET_CURRENT_USER', res.data)
        })
        .catch((err) => {
          if (err.response && err.response.status) {
            dispatch('requestAuthError', { error: err })
          }
        })
    } else {
      commit('SET_CURRENT_USER', null)
    }
  },
  signOut({ commit }, fullPath) {
    localStorage.clear()
    commit('SET_CURRENT_USER', null)
    commit('SET_LOGGED_IN', false)
    if (fullPath) {
      router.push({
        path: '/auth/login',
        query: { redirectFrom: fullPath }
      })
    } else {
      router.push('/')
    }
  },
  requestAuthError({ dispatch }, { error, fullPath }) {
    if (error && error.response) {
      if (error.response.status === 401) {
        dispatch('signOut', fullPath)
      } else if (error.response.status === 403) {
        router.push('/')
      } else if (error.response.status === 500) {
        router.push('/user#profileSettings')
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
